import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "heatmap-pagination" }

import TextBase from './TextBase.vue'
import SvgDisplay from './SvgDisplay.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

type Props = {
  totalItems: number
  itemsPerPage: number
  currentPage: number
  pageTitle?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeatmapPagination',
  props: {
    totalItems: {},
    itemsPerPage: {},
    currentPage: {},
    pageTitle: {}
  },
  emits: ['stepLeft', 'stepRight'],
  setup(__props: any, { emit: __emit }) {

const ariaLabels = {
  en: {
    stepBackwards: 'Step Backwards',
    stepForwards: 'Step Forwards'
  },
  sv: {
    stepBackwards: 'Stega bakåt',
    stepForwards: 'Stega framåt'
  }
}

const { locale } = useI18n()
const props = __props
const emits = __emit

const canStepLeft = computed(() => {
  if (props.itemsPerPage === 0 || props.totalItems === 0) {
    return false
  }
  if (props.currentPage === 0) {
    return false
  }
  return true
})

const canStepRight = computed(() => {
  if (props.itemsPerPage === 0 || props.totalItems === 0) {
    return false
  }
  return props.currentPage < Math.ceil(props.totalItems / props.itemsPerPage) - 1
})

function handleSpaceKey(event: Event, direction: 'stepLeft' | 'stepRight') {
  event.preventDefault() // Prevent space bar scrolling
  if (direction === 'stepLeft') {
    stepLeft()
  } else if (direction === 'stepRight') {
    stepRight()
  }
}

function stepLeft() {
  if (canStepLeft.value) {
    emits('stepLeft')
  }
}

function stepRight() {
  if (canStepRight.value) {
    emits('stepRight')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SvgDisplay, {
      src: "Icon-Chevron-Left_x16",
      class: _normalizeClass(["arrow arrow-left", { 'arrow-disabled': !canStepLeft.value }]),
      role: "button",
      "aria-label": ariaLabels[_unref(locale)].stepBackwards,
      tabindex: canStepLeft.value ? 0 : -1,
      onClick: stepLeft,
      onKeydown: [
        _withKeys(stepLeft, ["enter"]),
        _cache[0] || (_cache[0] = _withKeys((event) => handleSpaceKey(event, 'stepLeft'), ["space"]))
      ]
    }, null, 8, ["class", "aria-label", "tabindex"]),
    _createVNode(TextBase, {
      text: _ctx.pageTitle,
      type: "label",
      weight: "bold",
      textWrap: "nowrap"
    }, null, 8, ["text"]),
    _createVNode(SvgDisplay, {
      src: "Icon-Chevron-Right_x16",
      class: _normalizeClass(["arrow arrow-right", { 'arrow-disabled': !canStepRight.value }]),
      role: "button",
      "aria-label": ariaLabels[_unref(locale)].stepForwards,
      tabindex: canStepRight.value ? 0 : -1,
      onClick: stepRight,
      onKeydown: [
        _withKeys(stepRight, ["enter"]),
        _cache[1] || (_cache[1] = _withKeys((event) => handleSpaceKey(event, 'stepRight'), ["space"]))
      ]
    }, null, 8, ["class", "aria-label", "tabindex"])
  ]))
}
}

})